module.exports = __webpack_public_path__ + "img/team6.9d9ef0ae.png";